import { getGateway, getStatus } from "../invoice/invoiceMapper";

export function userMapperListResponse(json, headers) {
  return {
    data: json.allUser.map((resource) => ({
      ...resource,
      id: resource.objectId,
    })),
    total: headers.get("X-Total-Count") ? parseInt(headers.get("X-Total-Count").split("/").pop(), 10) : 1000,
  };
}

export function fixGetManyUsers(json) {
  return {
    data: json.allUser.map((resource) => ({
      ...resource,
      id: resource.objectId,
    })),
  };
}

export function userMapperGetOneResponse(params, json) {
  json.result.user.invoice.map((item) => {
    item.status = getStatus(item.status);
  });
  json.result.user.invoice.map((item) => {
    item.gateway = getGateway(item.gateway);
  });
  return {
    data: {
      ...json.result.user,
      id: json.result.user.objectId,
      walletBalance: json.result.user.walletBalance ? json.result.user.walletBalance.balance : 0,
      adminSpecialistCategories: json.result.user.specialistCategory && json.result.user.specialistCategory.map((item) => ({category : item})),
    },
  };
}